/**
 * PROGRAMAS · «FORMACIÓN PARA CADA JUGADOR»
 * =============================================================================
 * La fotografía a pantalla completa con el texto encima. Debajo, las cinco
 * tarjetas de programas y la franja de lo que incluyen todos.
 */

import { CONFIG } from '../config';
import { PantallaCompleta } from '../componentes/PantallaCompleta';
import { Icono, IconoEnAro, type NombreIcono } from '../componentes/Iconos';
import { Revelar } from '../componentes/Piezas';
import { useIdioma } from '../i18n/useIdioma';

export function Programas() {
  const { textos } = useIdioma();
  const t = textos.programas;

  const irA = (id: string) =>
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <>
      <PantallaCompleta
        id="programas"
        foto={CONFIG.fotos.portadaProgramas}
        alt={t.fotoAlt}
        etiqueta={t.etiqueta}
        titulo={<span className="oro">{t.titulo1}</span>}
        texto={t.titulo + '. ' + t.texto}
        encuadre="50% 22%"
        encuadreMovil="50% 15%"
      >
        <div className="acciones-fila">
          <button type="button" className="boton boton--marco" onClick={() => irA('contacto')}>
            <span>{t.boton}</span>
            <Icono nombre="flecha" tam={16} />
          </button>
        </div>
      </PantallaCompleta>

      <div className="caja">
        {/* Las cinco tarjetas. La rejilla tiene cuatro columnas en pantalla grande,
            así que la quinta ocupa el ancho que sobra: es como se ve en la
            referencia, con la última más ancha. */}
        <Revelar>
          <div className="reja-programas">
            {t.lista.map((p) => (
              <article className="programa" key={p.titulo}>
                <IconoEnAro nombre={p.icono as NombreIcono} tam={58} grosorIcono={24} />
                <h3 className="programa__titulo">{p.titulo}</h3>
                <p className="programa__texto">{p.texto}</p>
                <span className="programa__linea" aria-hidden="true" />
              </article>
            ))}
          </div>
        </Revelar>

        <Revelar>
          <div className="incluyen">
            <p className="incluyen__titulo">
              {t.incluyenTitulo}
              <br />
              <span className="incluyen__destacado">{t.incluyenDestacado}</span>
            </p>

            <div className="incluyen__reja">
              {t.incluyen.map((i) => (
                <div className="incluyen__item" key={i.titulo}>
                  <IconoEnAro nombre={i.icono as NombreIcono} tam={48} grosorIcono={20} />
                  <span className="tira-iconos__texto">{i.titulo}</span>
                </div>
              ))}
            </div>
          </div>
        </Revelar>
      </div>
    </>
  );
}
